const LivingCanvas = () => (
  <div className="living-canvas" aria-hidden="true">
    <div className="living-canvas-noise" />
  </div>
);

export default LivingCanvas;
